module.exports = __webpack_public_path__ + "img/tips2.504a9427.png";